import angular from 'angular'

import BadgeController from '../vd-badge.controller'
import { productImagePath } from '../../../filters/vd-product-image-path'

export default class ProductBadgeController extends BadgeController {
  constructor($attrs, vdCurrencyFilter, vdDisplayRoundFilter) {
    'ngInject'
    super($attrs)
    this._vdCurrencyFilter = vdCurrencyFilter
    this._vdDisplayRoundFilter = vdDisplayRoundFilter
  }

  $onInit() {
    this._ignoreCurrency = this.ignoreCurrency || false
  }

  getPrice() {
    if (this._ignoreCurrency) {
      return this._vdDisplayRoundFilter(this.price)
    } else {
      return this._vdCurrencyFilter(this.price)
    }
  }

  getProductName() {
    if (this.exactMatch || this.product.variant_parent_id) {
      return this.product.variant_name
    } else {
      return this.product.name
    }
  }

  hasPrice() {
    return Boolean(angular.isDefined(this.price) && this.price !== null)
  }

  getProductImage() {
    return productImagePath(
      this.product,
      'sm',
      this.exactMatch || this.product.variant_parent_id
    )
  }
}
